var map = {
	"./ar/menu.json": "./src/locale/ar/menu.json",
	"./cy/menu.json": "./src/locale/cy/menu.json",
	"./cz/menu.json": "./src/locale/cz/menu.json",
	"./da/menu.json": "./src/locale/da/menu.json",
	"./de/menu.json": "./src/locale/de/menu.json",
	"./en/menu.json": "./src/locale/en/menu.json",
	"./es/menu.json": "./src/locale/es/menu.json",
	"./fi/menu.json": "./src/locale/fi/menu.json",
	"./fr/menu.json": "./src/locale/fr/menu.json",
	"./hu/menu.json": "./src/locale/hu/menu.json",
	"./it/menu.json": "./src/locale/it/menu.json",
	"./ja/menu.json": "./src/locale/ja/menu.json",
	"./ko/menu.json": "./src/locale/ko/menu.json",
	"./kz/menu.json": "./src/locale/kz/menu.json",
	"./nl/menu.json": "./src/locale/nl/menu.json",
	"./pl/menu.json": "./src/locale/pl/menu.json",
	"./pt/menu.json": "./src/locale/pt/menu.json",
	"./ro/menu.json": "./src/locale/ro/menu.json",
	"./ru/menu.json": "./src/locale/ru/menu.json",
	"./sk/menu.json": "./src/locale/sk/menu.json",
	"./sv/menu.json": "./src/locale/sv/menu.json",
	"./vn/menu.json": "./src/locale/vn/menu.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/menu\\.json$";